import type { ThemeOptions } from '@mui/material/styles';

const body = "'Inter', system-ui, sans-serif";
const certificateHeading = "'LTA_Knockout', Impact, 'Arial Narrow', sans-serif";

const desktopUp = '@media (min-width:768px)';

export const fonts = {
  body,
  certificateHeading,
} as const;

export const typography: ThemeOptions['typography'] = {
  fontFamily: body,

  h1: {
    fontFamily: body,
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
    letterSpacing: '0.1px',
    [desktopUp]: { fontSize: '2rem', lineHeight: 1.2 },
  },
  h2: {
    fontFamily: body,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.5,
    letterSpacing: '0.005em',
  },
  h3: {
    fontFamily: body,
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.5,
    letterSpacing: '0.005em',
  },
  h4: { fontFamily: body, fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },
  h5: { fontFamily: body, fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },
  h6: { fontFamily: body, fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },

  body1: {
    fontFamily: body,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: body,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '0.1px',
  },
  body3: {
    fontFamily: body,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '0.015em',
  },

  subtitle1: {
    fontFamily: body,
    fontWeight: 400,
    fontSize: '1.125rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: body,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '0.1px',
  },

  caption: {
    fontFamily: body,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '0.1px',
  },

  overline: {
    fontFamily: body,
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '1.6px',
  },

  button: {
    fontFamily: body,
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    lineHeight: 1.4,
  },
};
